/**
 * Theme video resolver — videos live on the Ghost media CDN, not in the
 * theme bundle (mp4s are gitignored; CI deploys ship no /assets/videos/).
 * The manifest at assets/data/videos.json maps an image basename to its
 * CDN video URL. To add a video: upload the mp4 in Ghost Admin (or via
 * the Admin API media endpoint), add a manifest entry keyed by the
 * post's feature-image basename, commit, push (CI deploys).
 *
 * Cache-busting: the manifest is fetched at a FIXED path, and Ghost Pro's
 * Fastly edge caches /assets/* with a 1-year max-age. Without a unique
 * query the edge keeps serving whatever copy it warmed first, so a newly
 * pushed manifest entry never appears (the old copy is pinned for a year).
 * The manifest is ~1.4KB, so we append a per-load buster to always read the
 * live copy. Don't remove this or new hero videos silently won't show.
 */
(function () {
    let manifestPromise = null;

    window.tdcVideoUrl = function (basename) {
        if (!manifestPromise) {
            manifestPromise = fetch('/assets/data/videos.json?v=' + Date.now(), { cache: 'no-cache' })
                .then(function (res) { return res.ok ? res.json() : {}; })
                .catch(function () { return {}; });
        }
        return manifestPromise.then(function (manifest) {
            return manifest[basename] || null;
        });
    };
})();
